import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import {Done} from "@mui/icons-material";
import {Dialog} from "~/components/Dialog";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles<PortTheme>((theme) => ({
    iconContainer: {
        width: 100,
        height: 100,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFFFFF",
        padding: 22,
        fontWeight: 700,
        backgroundColor: theme.palette.additionalPrimary.main,
        backgroundClip: "padding-box",
        borderRadius: 106,
        borderStyle: "solid",
        borderColor: "#009ACF19",
        borderWidth: 15,
        "& .MuiSvgIcon-root": {
            width: 40,
            height: 40,
        }
    }
}));

type DetailsRequestSuccessModalProps = {
    onClose: () => void
    isOpen: boolean
}

export const DetailsRequestSuccessModal = (props: DetailsRequestSuccessModalProps) => {
    const {onClose, isOpen} = props;
    const history = useHistory();
    const classes = useStyles();

    const onSuccessfulClose = () => {
        history.push("/reconciliation");
    }

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <Grid container direction="column" alignItems="center">
                <Grid item>
                    <div className={classes.iconContainer}>
                        <Done color="inherit"/>
                    </div>
                </Grid>
                <Grid item marginTop="24px" textAlign="center">
                    <Typography variant="screenTitle"  color="primary">
                        Запрос отправлен
                    </Typography>
                </Grid>
                <Grid item marginTop="8px" textAlign="center">
                    <Typography variant="screenText" color="secondary" >
                        В ближайшее время вы получите детализацию на указанный адрес
                    </Typography>
                </Grid>
                <Grid item marginTop="40px" textAlign="center" width="100%">
                    <Button fullWidth variant="contained" color="additionalPrimary" onClick={onSuccessfulClose}>
                        Готово
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    )
}
